import { render, staticRenderFns } from "./ProductEditAwsDocuments.vue?vue&type=template&id=44c0a2ce"
import script from "./ProductEditAwsDocuments.vue?vue&type=script&lang=ts"
export * from "./ProductEditAwsDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports